import Node from './node';

export default class Comment extends Node {
  clone() {
    return new Comment(this.text, this.attributes, this.children.map((c) => c.clone()), this.owner);
  }
}
